module.exports = __webpack_public_path__ + "static/media/tour_basilica_virgen_coromoto.659b8b2e.jpg";